export interface PaginationWire {
  page?: number | null
  per_page?: number | null
  total_pages?: number | null
  total_count?: number | null
  has_next?: boolean | null
  has_prev?: boolean | null
}

export interface Pagination {
  page: number
  perPage: number
  totalPages: number
  totalCount: number
  hasNext: boolean
  hasPrev: boolean
}

/** Maps the backend pagination block and derives `hasNext` when the flag is missing. */
export function toPagination(payload: PaginationWire | null | undefined, fallbackCount: number): Pagination {
  const page = payload?.page ?? 1
  const perPage = payload?.per_page ?? 0
  const totalCount = payload?.total_count ?? fallbackCount
  const totalPages =
    payload?.total_pages ?? (perPage > 0 ? Math.max(1, Math.ceil(totalCount / perPage)) : 1)

  const hasNextByCount = perPage > 0 && page * perPage < totalCount
  const hasNextByPages = page < totalPages
  const hasNext = payload?.has_next === true || hasNextByCount || hasNextByPages
  const hasPrev = payload?.has_prev ?? page > 1

  return { page, perPage, totalPages, totalCount, hasNext, hasPrev }
}
